import { HttpApiError, HttpApiGroup } from "@effect/platform";
import { endpoint } from "../auth/endpoint";
import { DatabaseError, DataIntegrityError } from "../auth/errors";

import {
  NotifyPresenceInput,
  NotifyTypingInput,
  PublishNotificationResponse,
} from "../models/team/notification";

export const TeamNotificationGroup = HttpApiGroup.make("team-notification")
  .add(
    endpoint.merchant
      .post("notifyTyping", "/notifications/typing")

      .setPayload(NotifyTypingInput)
      .addSuccess(PublishNotificationResponse)
      .addError(HttpApiError.Forbidden)
      .addError(HttpApiError.ServiceUnavailable)
      .addError(HttpApiError.InternalServerError)
      .addError(DatabaseError)
      .addError(DataIntegrityError),
  )
  .add(
    endpoint.merchant
      .post("notifyPresence", "/notifications/presence")

      .setPayload(NotifyPresenceInput)
      .addSuccess(PublishNotificationResponse)
      .addError(HttpApiError.Forbidden)
      .addError(HttpApiError.ServiceUnavailable)
      .addError(HttpApiError.InternalServerError)
      .addError(DatabaseError)
      .addError(DataIntegrityError),
  )
  .prefix("/api");
